// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { start as startActiveStorage } from "@rails/activestorage"
import { initAll } from "govuk-frontend"

startActiveStorage()

// Every <body> Turbo swaps in needs the classes and component initialisation
// reapplying. turbo:load covers the initial load and navigations, but a form
// re-rendered with errors only fires turbo:render. A navigation fires both, so
// the js-enabled class marks a body that has already been initialised.
function initGovukFrontend() {
  if (document.body.classList.contains("js-enabled")) return

  document.body.classList.add("js-enabled")
  if ("noModule" in HTMLScriptElement.prototype) {
    document.body.classList.add("govuk-frontend-supported")
  }
  initAll()
}

document.addEventListener("turbo:load", initGovukFrontend)
document.addEventListener("turbo:render", initGovukFrontend)
